import { Grid, ListItem, ListItemText } from "@material-ui/core";
import React from "react"
import { emptyObject, getFieldForm } from "../../../redux/utils";

const styleCaption = {        
  border: "0px solid white",
  borderBottom: "1px solid white",
  borderRadius: "0px",
  backgroundColor: "#eaeaea",
  padding: 0,
  display: "flex",
  alignItems: "center",
};
const styleCaptionDev = {        
  border: "0px solid white",
  borderBottom: "1px solid rgb(163 163 163)",
  borderRadius: "0px",
  backgroundColor: "rgb(93, 93, 93)",
  padding: 4,
  display: "flex",
  alignItems: "center",
  color: "white",
};
const styleInput = {      
  border: "0px solid white",
  borderBottom: "1px solid white",
  borderRadius: "0px",
  backgroundColor: "#f7f7f7",
  padding: 0,
  display: "flex",
  alignItems: "center",
};
const styleInputDev = {      
  border: "0px solid white",
  borderBottom: "1px solid rgb(163 163 163)",
  borderRadius: "0px",
  backgroundColor: "rgb(205 205 205)",
  padding: 0,
  display: "flex",
  alignItems: "center",
};
export const WrapperField = ({devMode = false, fieldProps, Field, fake = false}) => {
  //console.log(!fieldProps.field || !fieldProps.field.fieldFn || eval(fieldProps.field.fieldFn)(fieldProps) );
  return (
    <>
      {Field && (!fieldProps.field || !fieldProps.field.type || getFieldForm(fieldProps.field)) &&
        (!fieldProps.field || !fieldProps.field.fieldFn || getFieldForm(eval(fieldProps.field.fieldFn)(fieldProps).field)) &&
        <WrapperComponent 
          devMode={devMode}
          caption={fieldProps.field.caption}
          Field={<Field devMode={devMode} fake={fake} {...{...fieldProps, field: {...fieldProps.field, columns: 12, variant: "standard", size: "small"}}}/>}
        />
      }
    </>
  );

}

export const WrapperComponent = ({devMode = false, caption, Field, disabled, Tooltip, inputContainerStyle = {}}) => {
  
  const SomeContent = React.forwardRef((props, ref) => <ListItemText  {...props} ref={ref} />);
  
  return (
    <>
      {Field && caption &&
        <>
          <Grid item xs={4} style={devMode ? styleCaptionDev : styleCaption}>
            <ListItem disablePadding style={devMode ? { padding: 0 } : emptyObject}>
              {
                //Tooltip && <Tooltip><SomeContent primary={caption} /></Tooltip>
              }
              {
                <ListItemText primary={caption} />
              }             
            </ListItem>
          </Grid>
          <Grid item xs={8} style={{...(devMode ? styleInputDev : styleInput), ...inputContainerStyle}} >
            {disabled ? <></> : Field}
          </Grid>    
        </>
      }
      {Field && !caption &&
        <>
          <Grid item xs={12} style={{...(devMode ? styleInputDev : styleInput), ...inputContainerStyle}}>
            {disabled ? <></> : Field}
          </Grid>    
        </>
      }

    </>
  )
}
